















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as utils from '@/utils';
import GenericDropdown from '@/components/GenericDropdown.vue';                       // @ is an alias to /src
import MomentSoldFFListComponent from '@/components/MomentSoldFFListComponent.vue';                       // @ is an alias to /src
import * as utils_tracker from '@/utils_tracker';
import * as utils_topshot from '@/utils_topshot';
import { MomentSoldFF, sortOrderTypes } from '@/MomentSoldFF'
import { FastFingerList } from '@/FastFingerList'
import { IPaginationResult } from '@/PaginationResult'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';           // @ is an alias to /src

@Component({
  name: 'FastFingers',
  components: { GenericDropdown, MomentSoldFFListComponent, ModalWrapperComponent }
})

export default class FastFingers extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop()
  public flowAddress: string

  // public reactive member variables available to the html template
  public lastFetchedURL: string = null;
  public moments: MomentSoldFF[] = []
  public fastFingerList: FastFingerList = null
  public paginationResult: IPaginationResult = null
  public numMoments: number = null

  // UI and filter options
  public user: { label: string, flowAddress: string } = { label: 'All users', flowAddress: null }
  public users: Array<{ label: string, flowAddress: string }> = []
  public sortOrders: Array<{ label: string, sort: string }> = [
    { label: 'Sort by Most Recent', sort: 'SoldDate_DESC' },
    { label: 'Sort by Fastest', sort: 'Speed_ASC' },
  ]
  public sortOrder: { label: string, sort: string } = this.sortOrders[0]

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }

  @Watch('user')
  public async onChangedUser(user: { label: string, flowAddress: string }) {
    this.user = user ? user : { label: 'All users', flowAddress: null }
    this.moments = []
    this.numMoments = 0
    this.pageNumberToLoadNext = 1
    this.flowAddressToUseWhenReady = null
    await this.fetchData(false, this.pageNumberToLoadNext)
  }

  public async onChangedSort(sortOrder: { label: string, sort: string }) {
    this.sortOrder = sortOrder
    this.pageNumberToLoadNext = 1
    this.flowAddressToUseWhenReady = null
    await this.fetchData(false, this.pageNumberToLoadNext)
  }

  public async onClickedUser(flowAddress: string) {
    for (const user of this.users) {
      if (user.flowAddress === flowAddress) {
        this.onChangedUser(user)
        break;
      }
    }
  }

  public showFAQ(): void {
    (this.$refs.FAQFastFingersComponent as ModalWrapperComponent).show('Fast Fingers FAQ', 'md', null)
  }  

  public async infiniteHandler(state: any): Promise<void> {
    const numReturned: number = await this.fetchData(true, this.pageNumberToLoadNext)
    if (numReturned === 0) {
      if (this.$store.state.devmode) console.log(`infiniteHandler(): state.complete after getting 0 items`)
      state.complete()
    } else {
      state.loaded();
    }
  }

  // private, non-reactive member variables
  private lastFetchSucceeded: boolean;
  private pageNumberToLoadNext: number = 1
  private flowAddressToUseWhenReady: string

  @Watch('$route.path')
  private async pathChanged(): Promise<void> {
    if (this.$store.state.devmode) console.log(`FastFingers.pathChanged() ${this.$route.path}`)
  }

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`);

    utils_tracker.page(this.$options.name)

    await this.pathChanged()

    // from props
    this.flowAddressToUseWhenReady = this.flowAddress

    // from url
    if (this.$route.query.address) this.flowAddressToUseWhenReady = this.$route.query.address as string

    await this.fetchData(false, this.pageNumberToLoadNext)
  }

  private async beforeDestroy() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`)
  }

  // add mode and flowAddress as query params to current url path
  private addParamsToURL() {
    let extra: string = ''
    if (this.user && this.user.flowAddress) extra += `&address=${encodeURIComponent(this.user.flowAddress)}`
    extra = extra.replace('&', '?')     // replace only the first one
    this.$router.replace(`${this.$route.path}${extra}`).catch(() => {})
  }

  private async fetchData(calledByInfiniteHandlerOrTimer: boolean, pageNumberWhenCalled: number): Promise<number> {
    this.addParamsToURL()

    const fakeMoment: MomentSoldFF = new MomentSoldFF(null)
    fakeMoment.momentID = 0
    fakeMoment.valueFMV = 0

    let url: string = utils.getURLprefix() + `/api/topshot/fastfingers/`;
    if (this.user && this.user.flowAddress) url += this.user.flowAddress
    url += `?page=${pageNumberWhenCalled}`;
    url += `&sortOrder=${this.sortOrder.sort}`;

    // don't fetch if we're in the middle of fetching same url
    if (this.loading) {
      if (this.lastFetchedURL === url || calledByInfiniteHandlerOrTimer) {
        if (this.$store.state.devmode) console.log(`FastFingers.fetchData() aborting calledByInfiniteHandler and we're already loading`)
        await utils.sleep(1000)     // wait 1 s so we don't go into 100% CPU infinite loop
        return
      }
    }

    this.$store.commit('setLoading', { loading: true });
    this.lastFetchedURL = url;

    try {
      // console.log(url)
      this.lastFetchSucceeded = false;
      const response: any = await utils.makeGetCall(url);

      // whoa, we got another call after this one, so let's abort this one cuz the latest one should take precedent
      if (this.lastFetchedURL !== url) return

      // in case old version
      if (utils.isClientOld()) {
        if (this.$store.state.devmode) console.log("Calling this.$router.go(0)");
        this.$router.go(0);
        this.$store.commit('setLoading', { loading: false });
        return;
      }

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }
      // pagination result
      this.paginationResult = response.data.paginationResult

      // load up the usernameCounts from the server
      interface userCount {
        usernameSlashAddress: string,
        count: number
      }
      const userCounts: userCount[] = response.data.userCounts
      if (userCounts && userCounts.length > 0) {
        this.users = [ { label: 'All users', flowAddress: null } ]
        for (const uc of userCounts) {
          let nameToUse: string = uc.usernameSlashAddress.split('/')[0]
          const flowAddress: string = uc.usernameSlashAddress.split('/')[1]
          if (nameToUse.length === 0) nameToUse = flowAddress
          const label: string = `${nameToUse} (${uc.count})`
          this.users.push( { label, flowAddress })
        }
      }

      // process flowAddressToUseWhenReady if it was passed into URL
      let needToRefetch: boolean = false
      if (this.flowAddressToUseWhenReady) {
        for (const user of this.users) {
          if (user.flowAddress === this.flowAddressToUseWhenReady)
          this.user = user
          needToRefetch = true
        }
      }
      this.flowAddressToUseWhenReady = null
      if (needToRefetch) {
        this.pageNumberToLoadNext = 1
        return await this.fetchData(false, this.pageNumberToLoadNext)
      }

      // load up subtotals
      this.numMoments = response.data.numMoments

      // load up the FastFingerList
      this.fastFingerList = new FastFingerList(response.data.fastFingerList)

      // load up the moments separately from the FastFingerList object in case we want to do paging (might do everything inside FastFingerList eventually)
      let newRawItems: MomentSoldFF[] = response.data.fastFingerList.moments
      if (newRawItems) {
        newRawItems = newRawItems.map((po) => new MomentSoldFF(po));
        if (pageNumberWhenCalled === 1) this.moments = [ fakeMoment ].concat(newRawItems);
        else this.moments = this.moments.concat(newRawItems)

        this.pageNumberToLoadNext++
        this.lastFetchSucceeded = true

        return newRawItems.length
      } else {
        this.lastFetchSucceeded = false;
        return 0
      }

    } catch (error) {
      if (error.toString().includes('Network Error') || error.toString().includes('status code 502')) utils.toast(this, 'Error', 'Undergoing Maintenance'); else utils.toast(this, 'Error', 'Could not load url')
      if (this.$store.state.devmode) console.log(error);
      return 0
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }

    this.$store.commit("setLoading", { loading: false });
  }  
}
